import { render, staticRenderFns } from "./JigsawList.vue?vue&type=template&id=c1cde11c"
import script from "./JigsawList.vue?vue&type=script&lang=js"
export * from "./JigsawList.vue?vue&type=script&lang=js"
import style0 from "./JigsawList.vue?vue&type=style&index=0&id=c1cde11c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports